<template>
    <div :class="couponClass">
        <div class="coupon-title">
            <div class="coupon-title_label tips">
                {{rewardNo}}
            </div>
            <div class="coupon-title_words tips">
                <span v-html="rewardTips"></span><span v-if="action" class="action" @click="doAction">{{action}}>></span>
            </div>
        </div>
        <div class="coupon-box">
            <div class="coupon-money">
                <img v-if="imgUrl" :src="imgUrl" />
            </div>
                <div class="coupon-detail" @click="btnClick">
                    <p class="coupon-detail-desc"><span v-html="couponDesc"></span></p>
                    <p :class="btnClass">{{couponBtn}}</p>
                </div>
            </div>
            <a @click="goCtn"  class="bc-rule bc-rule-1">
                <span>{{ruleTips}}</span>
                <span class="bc-triangle"></span>
            </a>
        </div>
</template>
<script>
import { getCoupon } from '../business/index';
import dialog from '../tools/dialog';
import { hottag } from '../tools/report';
import { itil } from 'base-libs';

export default {
    data: function() {
        return {
            isLoading: false
        }
    },
    props: {
        type: String,
        index: Number,
        imgUrl: String,
        rewardNo: String,
        state: String,
        rewardTips: String,
        couponDesc: String,
        couponBtn: String,
        ruleTips: String,
        btnLink: String,
        btnDisable: Boolean,
        actId: String,
        langObj: Object,
        params: Object,
        lang: String,
        action: String,
        actionUrl: String,
        hottagJump: String,
        successFn: Function
    },
    created: function() {
        let that = this;
        /*dialog({
            icon: 'ok',
            title: this.langObj.dialog_get_coupon_success_title,
            text_l1: this.langObj.dialog_get_coupon_success_desc_line1,
            text_l2: this.langObj.dialog_get_coupon_success_desc_line2,
            cancelTxt: this.langObj.dialog_later,
            sureTxt: this.langObj.dialog_recharge,
            cancelFn: function(){
                dialog.remove();
            },
            sureFn: () => {
                // HOTTAG hkwallet.smartone201810.jumpRecharge
                dialog.remove();
                location.href = that.langObj.jumpRechageLink;
            }
        });*/
    },
    methods: {
        goCtn: function(){
            hottag("action.smt.v1.tnc");
            this.$router.push({ path: '/tnc', query: {index:this.index, lang: this.lang }});
        },
        doAction: function(){
            location.href = this.actionUrl;
        },
        btnClick: function() {

            if (this.btnDisable) {
                console.log("disable");
                return;
            }

            if (!/micromessenger/.test(navigator.userAgent.toLowerCase()) || "st.moneydata.hk" === location.host) {
                if(this.index !== 0){ //如果不在微信，且第二第三个coupon，不能去guide。这个代码放这里，不合理
                    return;
                }
                hottag(this.hottagJump);  //跳转的hottag上报
                this.$router.push({ path: '/guide'});
                return;
            }

            const that = this;

            if (this.params.isHkUser * 1 === 0) {
                dialog({
                    icon: 'smile',
                    title: this.langObj.dialog_not_hkuser_title,
                    text_l1: this.langObj.dialog_not_hkuser_desc,
                    sureTxt: this.langObj.dialog_not_hkuser_btn,
                    cancelTxt: this.langObj.common_known,
                    cancelFn: function() {
                        hottag("action_smt_openhkwlater");
                        dialog.remove();
                    },
                    sureFn: function() {
                        hottag("action_smt_openhkw");
                        setTimeout(()=>{
                            location.href = that.langObj.jumpRegisterHkwalletLink;
                        }, 100)
                        dialog.remove();
                    }
                });
                return;
            }

            if (this.btnLink) { //只有btn2,btn3有link的配置
                hottag(this.hottagJump);  //跳转的hottag上报
                setTimeout(()=>{
                    location.href = this.btnLink;
                }, 100);
                return;
            }

            if (this.state * 1 === 2) { //只有btn1才会走到这里
                hottag("action_smt_v1_check_1"); //数码通活动_活动1_立即領取按钮
                setTimeout(()=>{
                    location.href = this.langObj.jumpCouponListLink;
                }, 100);
                return;
            }
            if (this.actId) {
                let that = this;
                if (this.isLoading) { //防重复点击
                    return;
                }
                hottag("action_smt_v1_claim"); //数码通活动_活动1_立即領取按钮
                this.isLoading = true;
                console.log("this.isLoading: ", this.isLoading);
                let promise = getCoupon(this.actId);
                promise.then((data) => {
                    /*
                        活动执行状态
                        0-活动执行成功
                        1-活动执行失败
                        2-不满足领取条件
                        3-超出活动配额
                        99-其他出错情况
                     */
                    if (data.exec_state * 1 === 0) {
                        dialog({
                            icon: 'ok',
                            title: this.langObj.dialog_get_coupon_success_title,
                            text_l1: this.langObj.dialog_get_coupon_success_desc_line1,
                            text_l2: this.langObj.dialog_get_coupon_success_desc_line2,
                            cancelTxt: this.langObj.dialog_later,
                            sureTxt: this.langObj.dialog_recharge,
                            cancelFn: function() {
                                hottag("action_smt_topuplater");
                                dialog.remove();
                            },
                            sureFn: () => {
                                // HOTTAG hkwallet.smartone201810.jumpRecharge
                                hottag("action_smt_topupnow");
                                setTimeout(()=>{
                                    location.href = that.langObj.jumpRechageLink;
                                });
                                dialog.remove();
                            }
                        });
                        itil(1345282); //～ITIL 数码通活动用户领取优惠券成功
                        this.successFn();
                    } else {
                        itil(1345283); //～ITIL 数码通活动用户领取优惠券失败
                        return Promise.reject({
                            retmsg: data.exec_state,
                            exec_state: data.exec_state
                        })
                    }
                    this.isLoading = false;
                }).catch((err) => {
                    dialog({
                        icon: 'error',
                        //title: this.langObj.err_system_busy,
                        text_l1: this.langObj.err_system_busy,
                        sureTxt: this.langObj.dialog_act_end_btn,
                        sureFn: function() {
                            dialog.remove();
                        }
                    });
                    itil(1345283); //～ITIL 数码通活动用户领取优惠券失败
                    this.isLoading = false;
                });
            }
        }
    },
    computed: {
        couponClass: function() {
            return 'coupon coupon-' + this.type;
        },
        btnClass: function() {
            if (this.btnDisable) {
                return 'coupon-detail-btn coupon-detail-btn_disable';
            } else {
                return 'coupon-detail-btn';
            }
        }

    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>